export enum SkillDimension {
  AcquisitionOrDevelopmentOfResources = 'acquisition-or-development-of-resources',
  ImprovementOfProfessionalPractice = 'improvement-of-professional-practice',
  DevelopmentOfDistancingOrReflexivity = 'development-of-distancing-or-reflexivity',
}
